<template>
    <div class="user-info">
        <h3 style="margin-top: 5px;text-align: center;">
            سفارش دهنده
        </h3>
        <div class="info">
            <img v-if="user.image" :src="user.image" alt="user image" />
            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="#000000" enable-background="new 0 0 24 24" viewBox="0 0 24 24"><g><rect fill="none" height="24" width="24"/></g><g><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"/></g></svg>
            <b>{{ user.name }} {{ user.family }}</b>
            <small>{{ user.mobile }}</small>
        </div>
        <br>
        <textarea :class="errAddress?'err':''" v-model="address" placeholder="آدرس دقیق برای دریافت پکیج را وارد کنید"></textarea>
    </div>
    <div class="myInfo">
        <PackageShablone :data="selected" @pay="pay" :btnName="'پرداخت ' + formatPrice(selected.price)"/>
    </div>
</template>
<script setup>
    import { defineProps, ref, computed, onMounted } from 'vue';
    import { useUserStore } from '@/stores/user'
    import { useFactorStore } from '@/stores/factor'
    import { useAlertStore } from '@/stores/alert';
    import PackageShablone from '@/components/dashboard/bodys/factor/PackageShablone.vue';
    const factor = useFactorStore()
    const user = useUserStore()
    const alert = useAlertStore()
    const props = defineProps({
        id:{
            type:Boolean,
            default: false
        }
    })
    const id = computed(()=>{return props.id})
    const selected = ref([])
    const address = ref('')
    const errAddress = ref(false)
    const formatPrice = (price) => {
        if (!price && price !== 0) return '-'
        return new Intl.NumberFormat('fa-IR').format(price) + ' تومان'
    };
    const pay = async (val) =>{
        if(address.value!==''){
            let des='';
            for (let i = 0; i < selected.value.details.length; i++) {
                des+= (selected.value.details[i].t>0?selected.value.details[i].t+' عدد سفته '+
                (selected.value.details[i].m==1000?
                    ' یک میلیارد تومانی':
                    (selected.value.details[i].m==2000?
                        ' دو میلیارد تومانی':
                        selected.value.details[i].m+' میلیون تومانی'
                    )
                ):'');
            }
            const id = await factor.addFactorReturnId({address:address.value,des:des,package:selected.value});
            if(parseInt(id)>0){
                return factor.pay(val,id,user)
            }else{
                alert.msg='عدم ارتباط مناسب';
            }
            errAddress.value=false
        }else{
            errAddress.value=true
            alert.msg='آدرس دقیق را پر کنید';
        }
    }
    onMounted(()=>{
        selected.value = factor.selectPackageWhereId(id.value)
    }) 
</script>
<style scoped>
    .user-info .info{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .user-info .info img{
        width: 50%;
        border-radius: 10px;
    }
    .user-info textarea {
        box-sizing: border-box;
        width: 100%;
        outline: none;
        height: 80px;
        text-align: center;
        border-radius: 10px;
    }
    .err {
        border-color: red;
    }
</style>